import { selectorFamily, useRecoilValueLoadable } from 'recoil';
import moment from 'moment';
import event from '../events/callReporting';
import { user } from '../atoms/user';
import { getStartingDate, startingDate } from '../atoms/startingDate';
import { endingDate, getEndingDate } from '../atoms/endingDate';
import { forceCallReportUpdate } from '../atoms/forceCallReportUpdate';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { methodNameEnum } from './makePHPRequest';
import { currentTeam } from '../atoms/currentTeam';

//This function will use the date picker values from atom when the value true is sent over and if false, it will
//be using the now -15 hours value
export const callReportingData = selectorFamily({
  key: 'callReportingData',
  get: (useDatePickerValues) => async ({ get }) => {
    try {
      const userInfo = get(user);
      get(forceCallReportUpdate);
      let start = '';
      let end = '';
      if (useDatePickerValues) {
        start = get(startingDate);
        end = get(endingDate);
      } else {
        start = moment().subtract(15, 'hours');
        end = moment();
      }
      const data = {
        call: methodNameEnum.GET_BUSINESS_DATA,
      };
      const businessData = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_DATA,
          payloadJsonString: JSON.stringify(data),
        })
      );
      const powerlistDialAttempts = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_POWERLIST_DIAL_ATTEMPTS,
          payloadJsonString: JSON.stringify({
            businessid: businessData?.response?.data?.result?.[0]?.businessid,
            startDate: start,
            endDate: end,
            call: 'getPowerlistDialAttemptsByBusiness',
          }),
        })
      );
      const attempts = powerlistDialAttempts?.response?.data?.dialAttempts?.reduce(
        (acc, item) => ({
          ...acc,
          [item.userid]: item,
        }),
        {}
      );
      const current = get(currentTeam);
      const eventPayload = event;
      eventPayload.startdate = start;
      eventPayload.enddate = end;
      eventPayload.connectionLimit =
        businessData?.response?.data?.result?.[0]?.connectionDuration;
      eventPayload.businessid = userInfo.businessid;
      eventPayload.apiKey = userInfo.apikey;
      eventPayload.timezone =
        businessData?.response?.data?.result?.[0]?.timezone_php;
      if (current?.name === 'singleUserFlag') {
        event.singleUser = true;
        event.calluserid = current.userid;
      } else {
        event.singleUser = false;
      }
      const result = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_USER_REPORTING,
          payloadJsonString: JSON.stringify(eventPayload),
        })
      );

      const users = result?.response?.data?.stats?.users || {};
      const updatedUsers = Object.fromEntries(
        Object.entries(users).map(([key, user]) => [
          key,
          {
            ...user,
            totalPowerlistDials: attempts?.[key]?.totalDialed ?? 0,
          },
        ])
      );

      const res = {
        charts: {
          ...result?.response?.data?.charts,
        },
        stats: {
          total: {
            ...result?.response?.data?.stats?.total,
          },
          users: updatedUsers,
        },
      };
      return res;
    } catch (error) {
      throw error;
    }
  },
});

export const getReportingData = async (userInfo, businessData) => {
  if (
    !userInfo?.businessid ||
    !userInfo?.apikey ||
    !businessData?.connectionDuration ||
    !businessData?.timezone_php
  ) {
    return;
  }

  event.startdate = getStartingDate();
  event.enddate = getEndingDate();
  event.connectionLimit = businessData.connectionDuration;
  event.businessid = userInfo.businessid;
  event.apiKey = userInfo.apikey;
  event.timezone = businessData.timezone_php;

  const result = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_USER_REPORTING,
      payloadJsonString: JSON.stringify(event),
    })
  );

  return result.contents;
};
